/** O envio de modelo que a tela acompanha, e onde ele fica guardado (ver `StatusDoEnvioDoModelo`). */
export const INTERVALO_DA_CONSULTA_MS = 5_000
export const LIMITE_DA_CONSULTA_MS = 10 * 60_000

export type EnvioAcompanhado = {
  nome: string
  mensagemId: number
  /** Quando o envio foi aceito (`Date.now()`): é de onde contam os 10 minutos. */
  em: number
}

/**
 * O último envio de cada conversa, **na sessão desta aba do navegador**.
 *
 * ⚠️ `sessionStorage`, e não estado do React: o Chatwoot recria o iframe do painel ao trocar
 * de conversa (`:key="currentChat.id + '-' + dashboardApp.id"`), e quem volta à conversa em
 * que acabou de enviar precisa reencontrar a linha — é ali que a falha aparece. Envio de
 * mais de 10 minutos não volta: a consulta já teria parado. Sem histórico: é só o último.
 */
const chave = (conversa: number) => `riodg.envio-do-modelo.${conversa}`

export function lembrarEnvio(conversa: number, envio: EnvioAcompanhado) {
  try {
    sessionStorage.setItem(chave(conversa), JSON.stringify(envio))
  } catch {
    // Armazenamento bloqueado (navegação privada, iframe de terceiro): a linha vale só nesta tela.
  }
}

/** O último envio aceito não tem id para acompanhar: o anterior deixa de ser "o último". */
export function esquecerEnvio(conversa: number) {
  try {
    sessionStorage.removeItem(chave(conversa))
  } catch {
    // Sem armazenamento, não havia o que esquecer.
  }
}

export function envioLembrado(conversa: number): EnvioAcompanhado | null {
  try {
    const lido = JSON.parse(sessionStorage.getItem(chave(conversa)) ?? 'null') as Partial<EnvioAcompanhado> | null

    if (
      !lido ||
      typeof lido.nome !== 'string' ||
      typeof lido.mensagemId !== 'number' ||
      typeof lido.em !== 'number' ||
      Date.now() - lido.em >= LIMITE_DA_CONSULTA_MS
    )
      return null

    return { nome: lido.nome, mensagemId: lido.mensagemId, em: lido.em }
  } catch {
    return null
  }
}
